import { urlCreateClient } from "./urls"

export const messagesAdd = {
    type : 'addClient',
    url : urlCreateClient,
    messageTextsOK : {
        messageTitle : 'Usuario creado con éxito',
        buttonLeft : 'Seguir agregando usuarios',
        buttonRight: 'Volver a clientes'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        messageUniqueKey : 'El nombre de la empresa y el CIF deben ser únicos para cada cliente',
        buttonLeft : 'Seguir agregando usuarios',
        buttonRight: 'Volver a clientes'
    }
}
export const messagesEdit = {
    type : 'updateClient',
    url : urlCreateClient,
    messageTextsOK : {
        messageTitle : 'Usuario actualizado con éxito',
        buttonRight: 'Volver a clientes'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        messageUniqueKey : 'El nombre de la empresa y el CIF deben ser únicos para cada cliente',
        buttonLeft : '',
        buttonRight: 'Volver a clientes'
    }
}
